module.exports = __webpack_public_path__ + "img/cryptokeeper_coin_binance.b43183a6.svg";